<template>
	<div>
		<claim-container v-once />
		<callout-container v-if="!isLoggedIn" />
		<how-to-container v-once />
		<types-container v-once />
		<milestones-container />
		<!-- <blog-container v-once /> -->
		<testimonials-container v-once />
		<!-- <partners-container v-once /> -->
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
// import BlogContainer from '@/components/sections/BlogContainer'
import CalloutContainer from '@/components/sections/CalloutContainer'
import ClaimContainer from '@/components/sections/ClaimContainer'
import HowToContainer from '@/components/sections/HowToContainer'
import MilestonesContainer from '@/components/sections/MilestonesContainer'
//import PartnersContainer from '@/components/sections/PartnersContainer'
import TestimonialsContainer from '@/components/sections/TestimonialsContainer'
import TypesContainer from '@/components/sections/TypesContainer'
import PageInfo from '@/mixins/PageInfo'

export default {
	name: 'Home',
	components: {
		// BlogContainer,
		CalloutContainer,
		ClaimContainer,
		HowToContainer,
		MilestonesContainer,
		//PartnersContainer,
		TestimonialsContainer,
		TypesContainer,
	},
	mixins: [AccountInfo, PageInfo],
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue